require("./style.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = { targetedOption: null };
    },
    onMount: function () {
        const $this = $(this.getEl()), $activeOption = $this.find('.sw-option.active');
        this.$target = $this.find('.sw-target');
        this.$target.width($activeOption.width() + 'px');
        const position = $activeOption.position();
        this.$target.css('left', (position ? position.left : 0) + 'px');
    },
    onInput: function (input) {
        let targetedOption = false;
        for (let option in input.options) {
            if (input.options[option].selected) {
                this.state.targetedOption = input.options[option].value;
                targetedOption = true;
                break;
            }
        }
        if (!targetedOption)
            this.state.targetedOption = input.options[0].value;
    },
    onSwitch: function (value, index, e) {
        if (this.state.targetedOption == value)
            return;
        this.state.targetedOption = value;
        const $activeOption = $(e.target);
        this.$target.width($activeOption.width() + 'px');
        const position = $activeOption.position();
        this.$target.css('left', (position ? position.left : 0) + 'px');
        this.emit('switch', value, index);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/Switcher/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("c6cb19"),
    marko_node0 = marko_createElement("div", {
        "class": "sw-target theme-bg"
      }, "1", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "sw-options d-flex flex-nowrap justify-content-around"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (input.options && input.options.length) {
    out.be("div", {
        "class": marko_classValue(marko_classValue([
          "sw",
          ((((input.class + " ") + (input.bg || "theme-bg-fade")) + " ") + (input.color || "white")) + "-text"
        ]))
      }, "0", component, null, 1);

    out.n(marko_node0, component);

    out.be("div", marko_attrs0, "2", component);

    marko_forOf(input.options, function({ label, value }, index) {
      const isActive = state.targetedOption == value

      out.e("div", {
          "class": marko_classValue("sw-option " + (isActive ? ("active " + (input.bg || "grey")) + "-text" : (input.color || "white") + "-text")),
          title: !isActive ? Locale("Switch to " + (label || "").toCapitalCase()) : ""
        }, "@" + index, component, 1, 0, {
          onclick: __component.d("click", "onSwitch", false, [
              value,
              index
            ])
        })
        .t(label, component);
    });

    out.ee();

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
